import { useRef } from 'react';

export const useDragAndDrop = () => {
  const dragRef = useRef<number | null>(null);

  const onDragStart = (index: number) => {
    dragRef.current = index;
  };

  const onDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const target = e.target as HTMLDivElement;
    target.style.opacity = '0.2';
  };

  const onDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const target = e.target as HTMLDivElement;
    target.style.opacity = '1';
  };

  const onDragDrop = (e: React.DragEvent<HTMLDivElement>, cb: (startIndex: number) => void) => {
    e.preventDefault();
    const target = e.target as HTMLDivElement;
    target.style.opacity = '1';
    if (typeof dragRef.current === 'number') {
      cb(dragRef.current);
    }
  };

  return { dragRef, onDragStart, onDragOver, onDragLeave, onDragDrop };
};
